import { render, staticRenderFns } from "./Shock.vue?vue&type=template&id=6437031e"
import script from "./Shock.vue?vue&type=script&lang=js"
export * from "./Shock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports